
import { Component, Vue } from 'vue-property-decorator';
import { clientApi } from '@api/client-api';
import { IBootstrapTableColumn } from '@/entity/shared/bootstrap';
import { ICancellableResult } from '@t/ajax-wrapper';
import { IClient } from '@/entity/shared/client';
import { IClientAddress } from '@/entity/shared/client-address';
import InputElement from '@c/shared/input-element.vue';
import { vxm } from '@/store';
import { moduleApiGraph } from '@t/module-api-graph';
import ContactGroupForList from '@c/shared/contact-group-for-list.vue';
import frenchLocale from 'date-fns/locale/fr';
import { format } from 'date-fns';
interface IDisplayNameForId
{
    [id: number]: string;
}
@Component({
    components: {
        InputElement,
        ContactGroupForList
    }
})
export default class ClientList extends Vue {
    private dictDisplayNames: IDisplayNameForId = {};
    private filterDataAllColumns: string = '';
    private isBusy: boolean = true;
    private promiseExport: boolean = false;
    private clientsPerPage: number = 50;
    private clientsCurrentPage: number = 1;
    private mySortBy: string = '';
    private mySortDesc: boolean = false;
    private filteredClients: IClient[] = [];
    private clients: IClient[] = [];
    private addresses: IClientAddress[] = [];
    private code: string = 'CLT';

    private clientFields: Array<IBootstrapTableColumn | string> = [
        { label: '', key: 'dummy', sortable: false },
        { label: 'Nom du Client', key: 'label', sortable: true },
        { label: 'Ligne Directe', key: 'directLine', sortable: true },
        { label: 'Adresse Mail', key: 'mail', sortable: true },
        { label: 'Site Web', key: 'webSite', sortable: true },
        { label: 'Contacts', key: 'users', sortable: false }
    ];

    private listOfFilters: any = {
        dummy: {
            columnName: 'dummy',
            value: ''
        },
        label: {
            columnName: 'label',
            value: ''
        },
        directLine: {
            columnName: 'directLine',
            value: ''
        },
        mail: {
            columnName: 'mail',
            value: ''
        },
        webSite: {
            columnName: 'webSite',
            value: ''
        },
        users: {
            columnName: 'users',
            value: ''
        }
    };

    get totalClients(): number {
        if (this.filteredClients && this.filteredClients.length !== this.clients.length) {
            return this.filteredClients.length;
        }
        return this.clients.length;
    }

    get fields(): Array<IBootstrapTableColumn | string> {
        return this.clientFields;
    }

    private async getAdGroupId(clientLabel: string): Promise<string> {
        const group = await moduleApiGraph.Client.api(
            "/groups/?$filter=displayName+eq+'Ind." + clientLabel + "'"
        ).get();
        if (group && group.value && group.value.length > 0) {
            return group.value[0].id;
        }
        return '';
    }

    get items(): IClient[] {
        if (this.filterDataAllColumns) {
            return this.clients.filter(
                (x) =>
                    (x.label && x.label.toLowerCase().includes(this.filterDataAllColumns.toLowerCase())) ||
                    (x.directLine && x.directLine.toLowerCase().includes(this.filterDataAllColumns.toLowerCase())) ||
                    (x.mail && x.mail.toLowerCase().includes(this.filterDataAllColumns.toLowerCase())) ||
                    (x.webSite && x.webSite.toLowerCase().includes(this.filterDataAllColumns.toLowerCase()))
            );
        }
        return this.clients;
    }

    private async checkGroupExistence(): Promise<void> {
        try {
            for (let i = 0; i < this.filteredClients.length; i++) {
                const res = await this.getAdGroupId(this.filteredClients[i].label as string);
                if (res && res.length > 0) {
                    // push guid en base ??
                    this.filteredClients[i].azureId = res;
                    await clientApi.patchBase(this.filteredClients[i].id + '', this.filteredClients[i]);
                } else {
                    // creation du groupe
                    await clientApi.createClient(this.filteredClients[i]);
                }
            }
        } catch (error) {}
    }

    private onFiltered(filteredItems: IClient[]) {
        this.filteredClients = filteredItems;
    }

    private editClient(item: IClient, _index: number, _event: Event): void {
        this.$router.push({ name: 'client-information', params: { id: item.id + '' } });
    }

    private createClientPage(): void {
        this.$router.push({ name: 'client-information', params: { id: '0' } });
    }

    private async mounted(): Promise<void> {
        vxm.app.changeTitleMain('Clients');
        vxm.app.changeTitleExt('Liste des clients');
        if (this.code === undefined || this.code === null) {
            this.code = 'CLT';
        }
        this.dictDisplayNames = {};
        const call = await clientApi.getAllByCode(this.code);
        if (call != null && call.cancelled === false && !call.error && call.datas != null) {
            this.clients = call.datas;
            this.filteredClients = call.datas;
            /// A ENLEVER LES COMMENTAIRES lorsqu'il sera possible et utile d'utiliser Graph d'azure AD 
            /* for (let i = 0; i < this.filteredClients.length; i++) {
                try {
                    const res = await this.getAdGroupId(this.filteredClients[i].label as string);
                    if (res && res.length > 0) {
                        const urlGraph = '/groups/' + res + '/members?$select=id,displayName,mail';
                        const graphData = await moduleApiGraph.Client.api(urlGraph).get();
                        if (graphData.value && graphData.value.length > 0)
                        {
                            this.dictDisplayNames[this.filteredClients[i].id!] = graphData.value.map(x => x.displayName).reduce((a, b) => a + b);
                        }
                    }
                } catch {}
            } */
        }
        this.isBusy = false;
    }

    async exportListClient(): Promise<void> {
        const sortKeySelected = this.mySortBy;
        const sortKeyDescSelected = this.mySortDesc;
        const listClients =
            this.filteredClients && this.filteredClients.length !== this.clients.length
                ? this.filteredClients.map((x) => x.id)
                : this.filteredDataByColumn && this.filteredDataByColumn.length !== this.clients.length
                    ? this.filteredDataByColumn.map((x) => x.id)
                    : this.clients.map((x) => x.id);
        await this.generateListClient(
            clientApi.exportClientData(listClients as any, sortKeySelected as string, sortKeyDescSelected as any),
            `Liste_des_clients_${this.formatDate(new Date())}.xlsx`
        );
    }

    get filteredDataByColumn(): IClient[] {
        const keys = Object.keys(this.listOfFilters);
        const filtersApplied = keys.filter((x) => this.listOfFilters[x].value.length > 0);
        if (filtersApplied.length > 0) {
            return this.clients.filter((p) => filtersApplied.every((f) => this.filterListByColumn(f, p)));
        }
        return this.clients;
    }

    public filterListByColumn(key: string, x: IClient): boolean {
        if (key === 'label' && this.listOfFilters.label.value != null) {
            return x.label ? x.label.toUpperCase().includes(this.listOfFilters.label.value.toUpperCase()) : false;
        } else if (key === 'directLine' && this.listOfFilters.directline === undefined) {
            return x.directLine ? x.directLine.replaceAll(' ', '').replaceAll('.', '').includes(this.listOfFilters.directLine.value.replaceAll(' ', '').replaceAll('.', '')) : false;
        } else if (key === 'mail' && this.listOfFilters.mail.value != null) {
            return x.mail ? x.mail.toUpperCase().includes(this.listOfFilters.mail.value.toUpperCase()) : false;
        } else if (key === 'webSite' && this.listOfFilters.webSite.value != null) {
            return x.webSite ? x.webSite.toUpperCase().includes(this.listOfFilters.webSite.value.toUpperCase()) : false;
        } else if (key === 'users') {
            const displayNames = this.dictDisplayNames[x.id!];
            if (displayNames) {
                return displayNames.toUpperCase().includes(this.listOfFilters.users.value.toUpperCase());
            } else return false;
        } else if (key === 'dummy') {
            return false;
        } else return false;
    }

    private strcmp(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }

    private myCompare(itemA: any, itemB: any, key: string) {
        let a, b;
        if (key === 'label' || key === 'mail' || key === 'webSite') {
            a = itemA[key];
            b = itemB[key];
            if (a === null) a = '';
            if (b === null) b = '';
            return this.strcmp(a.toUpperCase(), b.toUpperCase());
        }
        if (key === 'directLine') {
            a = itemA[key];
            b = itemB[key];
            if (a === null) a = '';
            if (b === null) b = '';
            return this.strcmp(a.replaceAll(' ', '').replaceAll('.', ''), b.replaceAll(' ', '').replaceAll('.', ''));
        }
    }

    private formatDate(date: Date): string {
        return format(new Date(String(date)), 'yyyy-MM-dd', { locale: frenchLocale }) ?? '';
    }

    private async generateListClient(request: Promise<ICancellableResult<string>>, reportName: string): Promise<void> {
        this.promiseExport = true;
        const response = await request;
        if (response && response.datas) {
            const blob = new Blob([response.datas], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = reportName;
            link.click();
            this.promiseExport = false;
        }
        // We wait for the file to download before removing loading state
        setTimeout(() => {
            this.promiseExport = false;
        }, 1000);
    }
}
